<template>
    <a-modal
    :confirmLoading='confirmLoading'
    :title='title'
    :visible='visible'
    :width='1000'
    :ok-button-props="{ style: { display: 'none' } }"
    cancel-text="关闭"
    @cancel='handleCancel'
    @ok='handleOk'>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :span="8">
            <a-form-item label="表单名称">
              <j-input placeholder="请输入名称" v-model="queryParam.name"></j-input>
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="addFormListHandle(record)">添加</a>
        </span>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
  import '@/assets/less/TableExpand.less'
    import { getAction,postAction,deleteAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  
  export default {
    name: "CsimSchemaPeriodUnSelectFormListModel",
    mixins:[JeecgListMixin],
    components: {
      JInput,
    },
    props:{
    },
    data () {
      return {
        title: "表单选择",
        periodData: {},
        visible: false,
        confirmLoading: false,
        description: '项目受试者自定义配置管理页面',
        // 表头
        columns: [
          {
            title: '表单',
            dataIndex: 'name',
            align: 'center',
            ellipsis: true
          },
          {
            title: '简介',
            dataIndex: 'intro',
            align: 'center',
            ellipsis: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/scheme/page/form/list",
        },
        disableMixinCreated:true,
        viewVisible:false,
        current:{},
      }
    },
    mounted(){
    },
    methods: {
      formItemSetHandle(record){
        this.periodData = record
        if (this.periodData.schemeId && this.periodData.id) {
          this.loadForm();
        } else {
          this.$message.warn("请先选择周期")
        }
      },
      loadForm(){
        this.visible = true;
        this.baseQueryParam.schemeId = this.periodData.schemeId
        this.loadData()
      },
      onViewClose(){
        this.viewVisible = false
      },
      addFormListHandle(record){
        postAction('/scheme/period/form/save',{
          formId: record.id,
          formName: record.name,
          periodId: this.periodData.id,
        }).then(res=>{
          if(res.success){
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
        }).finally(()=>{
          this.loadForm();
          this.$emit("refreshPeriodFormList");
        })
      },
      handleCancel() {
        this.visible = false
      },
      handleOk() {
        this.handleCancel()
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>